import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { cleanHttpRefererFromStorage } from './TrackingProvider';
import { useTrackEvent } from './useTrackEvent';
import { EventName } from './events';
import { emitPageViewEvent } from './avro';

export function TrackRouting() {
  const trackEvent = useTrackEvent();
  const router = useRouter();

  useEffect(() => {
    cleanHttpRefererFromStorage();

    const trackPageView = () => {
      // setTimeout for reasons of:
      // A) Give added time / tick for identity Cookie to be set (additional safety measure)
      // B) timneutkens does it in next-plugin-google-analytics for equivalent handler https://github.com/vercel/next.js/blob/5fff814ca1e7f78b50535a55d6f99bd842c4e049/packages/next-plugin-google-analytics/src/on-init-client.js
      setTimeout(() => {
        trackEvent(EventName.NAVIGATE, {});
        trackEvent(EventName.PERFORMANCE_MOUNT, {
          timeToMount: window.performance.now(),
          timeToMountType: 'page-ready',
        });

        // Avro page view
        emitPageViewEvent();
      }, 0);
    };

    const hasQueryParams = !!location.search;

    /**
     * 1) Track initial page view
     *
     * Next.js is triggering `routeChangeComplete` if the URL has query params in it
     * and that was causing us to track `navigate_blog` twice.
     *
     * We want to avoid double tracking for any campaign that we run.
     */
    if (!hasQueryParams) {
      trackPageView();
    }

    /**
     * 2) Track subsequent page views from client side navigation
     */
    router.events.on('routeChangeComplete', trackPageView);

    return () => {
      cleanHttpRefererFromStorage();
      router.events.off('routeChangeComplete', trackPageView);
    };
    // This is based on /blog setup: https://github.com/zapier/blog/blob/f0e20c377f98013297b92f9809728cdf61045868/src/components/Navigation/NavigationTracker.tsx#L50
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
